export default __webpack_public_path__ + "images/S9.58dfc20.png";